import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const RenewalPlan = ({ packageName }) => {
  const { t } = useTranslation();

  return (
    <Box className="content-item">
      <Typography className="label">{t('renewalPlan')}</Typography>
      <Typography className="content">{packageName}</Typography>
    </Box>
  );
};

export default RenewalPlan;
